import { apiClient } from './client'
import { ApiError } from './errors'

// Matches UserProfileOut from the backend (snake_case, FastAPI default)
export interface UserProfile {
  id: number
  email: string
  first_name?: string
  last_name?: string
  preferred_name?: string
  date_of_birth?: string
  mobile_phone_number?: string
  address_line1?: string
  address_line2?: string
  suburb?: string
  city?: string
  postcode?: string
  identity_verified: boolean
  aml_verified: boolean
  authenticator_app_enabled: boolean
  legacy_otp_enabled: boolean
  marketing_opted_in: boolean
}

// Matches UserProfileUpdateIn from the backend
export interface UserProfileUpdate {
  first_name?: string
  last_name?: string
  preferred_name?: string
  mobile_phone_number?: string
  address_line1?: string
  address_line2?: string
  suburb?: string
  city?: string
  postcode?: string
}

export async function fetchUserProfile(): Promise<UserProfile> {
  try {
    const response = await apiClient.get<UserProfile>('user/profile')
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function updateUserProfile(
  data: UserProfileUpdate
): Promise<UserProfile> {
  try {
    const response = await apiClient.put<UserProfile>('user/profile', data)
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function updatePassword(data: {
  currentPassword: string
  newPassword: string
}): Promise<void> {
  try {
    await apiClient.put('user/password', {
      current_password: data.currentPassword,
      new_password: data.newPassword
    })
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}
